import { initGTM } from "../subscribers/gtm";

const event = {
  name: "start-gtm-tracking",
  subscribers: [initGTM],
};

export default event;
